import React from 'react';

const SpinnerODM = () => {
    return (
        <div style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            width: '100%',
            opacity: 0.5,
            position: "absolute",
            zIndex: 2,
            top: 0,
            left: 0,
        }}>
            <div
                className="spinner-grow"
                style={{
                    width: "3rem",
                    height: "3rem",
                }}
                role="status"
            >
                <span className="visually-hidden">Loading...</span>
            </div>
        </div>
    );
}

export default SpinnerODM;


